export default {
  Currency: 1,
  Asset: 2,
};
